module.exports = "/5/1-cac-thao-tac-co-ban-voi-mang-mot-chieu/index.html.c358cb5702d7e0848c1d0fcafea76326.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30082.md
 ** module id = 553
 ** module chunks = 0
 **/